import type { ReactNode } from 'react';
import { Box } from '@mui/material';

export const ResponsiveCardGrid = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 280px), 1fr))',
      gap: { xs: 2, sm: 3 },
      '& > *': { minWidth: 0 },
    }}
  >
    {children}
  </Box>
);
